import differenceInDays from 'date-fns/differenceInDays';

const getFsExpiresInDays = (userFsValue) => differenceInDays(new Date(userFsValue), new Date());

export { getFsExpiresInDays };
